import { combineReducers } from 'redux';
import uniq from 'lodash/uniq';
import { CreateUserViewModel } from 'stageclip-common';

import { ClientsActionTypes } from 'api/clients/clients.action-types';
import { ClientActions } from 'api/clients/clients.actions';
import { InternalActionTypes } from 'constants/actionTypes';
import { ById } from 'store/normalizedState';
import * as ReducerHelper from './reducerHelper';

const usersAllIdsReducer = (state: string[] = [], action: ClientActions) => {
  switch (action.type) {
    case ClientsActionTypes.FETCH_CLIENT_USERS_REQUEST: {
      return [];
    }
    case ClientsActionTypes.FETCH_CLIENT_USERS_SUCCESS: {
      return action.payload.result;
    }
    case ClientsActionTypes.ADD_CLIENT_USERS_SUCCESS:
    case ClientsActionTypes.EDIT_CLIENT_USER_SUCCESS: {
      return uniq([...state, action.payload.result]);
    }
    case InternalActionTypes.UserDeleted:
      return ReducerHelper.removeId(state, action.meta.userId);
    default:
      return state;
  }
};

const usersByIdsReducer = (state: ById<CreateUserViewModel> = {}, action: ClientActions) => {
  switch (action.type) {
    case ClientsActionTypes.FETCH_CLIENT_USERS_REQUEST: {
      return {};
    }
    case ClientsActionTypes.FETCH_CLIENT_USERS_SUCCESS:
    case ClientsActionTypes.ADD_CLIENT_USERS_SUCCESS:
    case ClientsActionTypes.EDIT_CLIENT_USER_SUCCESS: {
      return ReducerHelper.updateAll(state, action.payload.entities.users);
    }
    case InternalActionTypes.UserDeleted:
      return ReducerHelper.removeItem(state, action.meta.userId);
    default:
      return state;
  }
};

export const clientsUsersReducer = combineReducers({ byId: usersByIdsReducer, allIds: usersAllIdsReducer });
